//* Importing background image
import BgVestibular from "../../assets/images/bg_vestibular.jpeg";

//* Importing logo
import Logo from "../../assets/images/logo-ontest.png";

//* Importing date utility
import { dateUtils } from "../../utils/dateUtils";

//* Importing LoginForm component
import { LoginForm } from "./_components";

export function LoginView() {
  const containerStyles = {
    height: "100vh",
  };

  const backgroundImageStyles = {
    overflow: "hidden" as const,
    backgroundImage: `url(${BgVestibular})`,
    backgroundSize: "cover" as const,
    padding: 0,
    margin: 0,
    height: "100vh",
  };

  const cardBodyStyles = {
    paddingLeft: "1rem",
    paddingRight: "1rem",
  };

  const logoStyles = {
    maxHeight: 70,
  };

  const contentPadding = {
    padding: "1rem",
    paddingBottom: 0,
    marginTop: 10,
  };

  return (
    <div style={containerStyles}>
      <div className="row" style={{ backgroundColor: "white", margin: 0 }}>
        <div
          className="col-md-6 col-12 col-sm-12 col-lg-4 col-xl-4"
          style={{ margin: 0, padding: 0 }}
        >
          <div className="card" style={{ height: "100vh", margin: 0 }}>
            <div className="card-body" style={cardBodyStyles}>
              <br />
              <div className="text-center">
                <div className="logo">
                  <img
                    style={logoStyles}
                    src={Logo}
                    height="60"
                    alt="OnTest Portal Logo"
                  />
                </div>
              </div>
              <br />

              <div style={contentPadding}>
                <h4
                  className="font-18 m-b-5 text-center header-title"
                  style={{ fontSize: 18 }}
                >
                  Bem vindo !
                </h4>
                <p className="text-muted text-center" style={{ fontSize: 14 }}>
                  Faça login para continuar.
                </p>

                <LoginForm />
              </div>
              <div className="text-center" style={{ marginTop: 20 }}>                
                <p style={{ fontSize: 14 }}>
                  © {dateUtils.getCurrentYear()} OnTest
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-sm-6 col-12 col-lg-8 col-xl-8 d-none d-md-block"
          style={backgroundImageStyles}
        ></div>
      </div>
    </div>
  );
}
